import React from "react";
import { X } from "lucide-react";

export default function StudentDetailModalHeader({
  iconSrc,
  onMouseDown,
  onClose,
}) {
  return (
    <div
      className="flex justify-between items-center px-6 py-5 border-b border-gray-100 z-20 shrink-0 cursor-move bg-white"
      onMouseDown={onMouseDown}
    >
      <h3 className="text-xl font-black text-[#2C3E30] flex items-center gap-2 font-do-hyeon">
        <img src={iconSrc} width={28} alt="icon" /> 학생 상세 정보
      </h3>
      <button
        onClick={onClose}
        className="text-gray-400 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 p-2 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-gray-200"
      >
        <X size={20} />
      </button>
    </div>
  );
}
